import { accessorialLabel, SKIP_REASON_TEXT } from '../policies/accessorial-labels.policy';
import type { TripAccessorials } from '../trip-accessorials.api';

/** What was looked at and not proposed, with why, so a missing charge is explained rather than silent. */
export function SkippedTypes({ skipped }: { skipped: TripAccessorials['skipped'] }) {
  if (skipped.length === 0) return null;
  return (
    <section aria-label="Not proposed" className="rounded-lg border border-line bg-surface p-4">
      <h3 className="mb-2 text-sm font-semibold text-fg">Not proposed</h3>
      <ul className="flex flex-col gap-1 text-sm text-muted">
        {skipped.map((item) => (
          <li key={item.type}>
            <span className="font-medium text-fg">{accessorialLabel(item.type)}</span>: {SKIP_REASON_TEXT[item.reason]}
          </li>
        ))}
      </ul>
    </section>
  );
}
